export enum StatutFluxEnum {
    EN_ATTENTE,
    ENVOYE,
    PUBLIE,
    REFUSE,
    ANNULE
}
